import React from 'react'
import classes from './styles.module.scss'

const url = 'https://app.powerbi.com/view?r=eyJrIjoiYzA1ZjI0ZTMtOGRhZS00NjVlLTliOTgtMWVmOTk5ODE1MzU4IiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'

const PsdDashboard = () => {
  return (
    <div className={classes['psd-dashboard']}>
      <iframe src={url} title="psd-dashboard" width="100%" height="100%" />
    </div>
  )
}

export default PsdDashboard